import * as React from "react";

function UpChevron(props) {
  return (
    <svg viewBox="0 0 256 256" width="1em" height="1em" {...props}>
      <path d="M128 48.907l-128 128 30.187 30.186L128 109.28l97.813 97.813L256 176.907z" />
    </svg>
  );
}

const MemoUpChevron = React.memo(UpChevron);
export default MemoUpChevron;
